import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Delinquent';

export const DelinquentTaxRoutes = [
  {
    path: '/tax/delinquent',
    name: 'Delinquent Tax',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/TaxDelinquent.vue'),

    children: [
      {
        path: 'juneResale',
        name: 'June Resale',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/Delinquent/JuneResale/JuneResale.vue'),
        children: [
          {
            path: 'resalepropertylist',
            name: 'Tax - Delinquent Tax - Resale Property List',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/JuneResale/ResalePropertyList.vue'),
          },
          {
            path: 'bidderregistration',
            name: 'Tax - Delinquent Tax - Bidder Registration',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/JuneResale/BidderRegistration.vue'),
          },
          {
            path: 'dayofsale',
            name: 'Tax - Delinquent Tax - Day of Sale',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/JuneResale/DayOfSale.vue'),
          },
          {
            path: 'resalereports',
            name: 'Tax - Delinquent Tax - Reports',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/JuneResale/JuneResaleReports.vue'),
          },
        ],
      },
      {
        path: 'personalTaxWarrants',
        name: 'Personal Tax Warrants',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/Delinquent/warrants/PersonalTaxWarrants.vue'),
        children: [
          {
            path: 'taxWarrants',
            name: 'Tax - Delinquent Tax - Tax Warrants',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/warrants/TaxWarrants.vue'),
          },
          {
            path: 'browse',
            name: 'Tax - Delinquent Tax - Browse',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/warrants/Browse.vue'),
          },
          {
            path: 'taxWarrantReports',
            name: 'Tax - Delinquent Tax - TaxWarrantReports',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/Reports/Reports.vue'),
          },
        ],
      },
      {
        path: 'commissionerssale',
        name: 'Commissioners Sale',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/Delinquent/CommissionersSale/CommissionersSale.vue'),
        children: [
          {
            path: 'commissionerspropertylist',
            name: 'Tax - Delinquent Tax - Commissioners Property List',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/CommissionersSale/CommissionersSalePropertyList.vue'),
          },
          {
            path: 'commissionersbidderregistration',
            name: 'Tax - Delinquent Tax - Commissioners Bidder Registration',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/CommissionersSale/CommissionersSaleBidderRegistration.vue'),
          },
          {
            path: 'commissionersresalereports',
            name: 'Tax - Delinquent Tax - Commissioners Reports',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/Delinquent/CommissionersSale/CommissionersSaleReports.vue'),
          },
        ],
      },
    ],
  },

];

// which roles have to define need to know
DelinquentTaxRoutes.forEach((element, index) => {
  DelinquentTaxRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.DelinquentTaxAuth], next);
  };
});

export default DelinquentTaxRoutes;
